module.exports = __webpack_public_path__ + "img/AG.1b75dde5.png";